import createCrudVuexModule from "@/store/crud";

export const legalDocumentTemplateCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/legal-document-template-category",
});

export const workspaceLegalDocumentTemplateCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/legal-document-template-category",
});

export const managementLegalDocumentTemplateCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/legal-document-template-category",
});

export const legalDocumentTemplate = createCrudVuexModule({
  namespaced: true,
  path: "/library/legal-document-template",
});

export const workspaceLegalDocumentTemplate = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/legal-document-template",
});

export const managementLegalDocumentTemplate = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/legal-document-template",
});
